// extracted by mini-css-extract-plugin
export var barContainer = "_v-0";
export var extraThin = "_v-3";
export var fillBar = "_v-6";
export var fillContainer = "_v-4";
export var overflow = "_v-8";
export var overflowContainer = "_v-5";
export var regular = "_v-7";
export var thick = "_v-1";
export var thin = "_v-2";